import React, { useState, useEffect  } from 'react'
import scrollTo from 'gatsby-plugin-smoothscroll';
import axios from 'axios';
function TabLink() {
const [posts, setPosts] = useState([]);
const [loading, setLoading] = useState(false);
let api = 'https://tallysolutions-uae.com/tallyprime/api/wp-json/wp/v2/faq';
useEffect(() => {
setLoading(true)
axios.get(api)
.then(res => {
//console.log(res)
setPosts(res.data)
setLoading(false)
})
}, [setPosts])
return (
<React.StrictMode>
   {
   loading && 
   <div></div>
   }
   {!loading &&
       
   <>

   
 <ul className="nav nav-tabs">
   {posts.map((post,i) => (
 
 <li><a  onClick={() => scrollTo('#faq-qua')}  href={'#'+post.acf.type.replace(/-|\s/g, '_').toLowerCase()} data-toggle="tab" className={i ? '' : 'active'}>{post.acf.type}</a></li>
     

   ))}
</ul>
      </>

   }
</React.StrictMode>
)
}
export default TabLink;